module.exports = __webpack_public_path__ + "assets/img/health-potion.860012af.png";